import { Apollo } from 'src/gql/generated';

export type UserSubset = Pick<
  Apollo.User,
  'avatarColor' | 'displayName' | 'email' | 'firstName' | 'id' | 'lastName' | '__typename'
>;
export type OrgSubset = Pick<Apollo.Org, 'avatarColor' | 'id' | '__typename' | 'name'>;

export type AccountSubset = UserSubset | OrgSubset;

export type GroupSubset = Pick<Apollo.Group, 'avatarColor' | '__typename' | 'name'>;

interface OrgWithAvatarImg extends Pick<Apollo.Org, 'avatarColor' | '__typename'> {
  avatarImg: Pick<Apollo.DocFile, 'filestackUrl' | '__typename'> | null;
}
export interface UserWithOrgImg extends Pick<Apollo.User, '__typename'> {
  org: OrgWithAvatarImg | null;
}
export interface UserWithOrg extends Pick<
  Apollo.User,
  'avatarColor' | 'displayName' | 'id' | 'role' | '__typename'
> {
  org: Pick<Apollo.Org, 'id' | '__typename'> | null;
}

export function accountTypenameToAccountType(
  __typename: AccountSubset['__typename']
): Apollo.AccountType {
  switch (__typename) {
    case 'User':
      return Apollo.AccountType.User;
    case 'Org':
      return Apollo.AccountType.Org;
  }
}
